var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmerica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_10",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.84 0H-8.99998V36.7579H60.84V0Z",
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 4.2413H60.84H-9ZM60.84 9.89637H-9H60.84ZM-9 15.5514H60.84H-9ZM60.84 21.2065H-9H60.84ZM-9 26.8616H60.84H-9ZM60.84 32.5166H-9Z",
    fill: "#25272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.84 32.5166H-9M-9 4.2413H60.84H-9ZM60.84 9.89637H-9H60.84ZM-9 15.5514H60.84H-9ZM60.84 21.2065H-9H60.84ZM-9 26.8616H60.84H-9Z",
    stroke: "#FDFBFB",
    strokeWidth: 2.82753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.936 0H-8.99998V19.7927H18.936V0Z",
    fill: "#3C3B6E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmerica);
export default __webpack_public_path__ + "static/media/america.c669b13f2aa96e177ccd2178d70a4422.svg";
export { ForwardRef as ReactComponent };